// extracted by mini-css-extract-plugin
export default {"main-header":"MainHeader_main-header__Jy334","main-image":"MainHeader_main-image__2VTJX"};